import React, { useEffect, useMemo, useState } from "react";
import api from "../lib/api";
import { Input } from "../components/ui/input";
import { formatDate } from "../lib/utils";

const humanize = (a) => (a || "").replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
const detailOf = (e) => {
  const m = e.meta || {};
  if (m.name) return m.name;
  if (m.email) return m.email;
  if (Array.isArray(m.changed)) return `changed: ${m.changed.join(", ")}`;
  return e.target_id || "—";
};

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [action, setAction] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/audit").then((r) => setRows(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);
  const actions = useMemo(() => Array.from(new Set(rows.map((r) => r.action))).sort(), [rows]);
  const filtered = rows.filter((e) => {
    if (action && e.action !== action) return false;
    if (!q) return true;
    const hay = `${e.actor_name} ${humanize(e.action)} ${detailOf(e)}`.toLowerCase();
    return hay.includes(q.toLowerCase());
  });
  return (
    <div className="space-y-5">
      <div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-blue-600 font-semibold">Administration</div>
        <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900 mt-1">Audit Log</h1>
        <p className="text-sm text-slate-500 mt-1">Recent activity across your workspace (latest 500 events).</p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Input placeholder="Search actor, action, details…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs" />
        <select value={action} onChange={(e) => setAction(e.target.value)} className="border border-border rounded-md px-3 text-sm bg-white">
          <option value="">All actions</option>
          {actions.map((a) => <option key={a} value={a}>{humanize(a)}</option>)}
        </select>
      </div>
      <div className="surface-card overflow-x-auto">
        <table className="w-full text-sm table-tight">
          <thead className="bg-slate-50"><tr className="text-left text-[10px] uppercase tracking-[0.1em] text-slate-500">
            <th>Time</th><th>Actor</th><th>Action</th><th>Details</th>
          </tr></thead>
          <tbody>
            {loading && <tr><td colSpan={4} className="text-center text-slate-400 py-12 text-xs">Loading…</td></tr>}
            {!loading && filtered.length === 0 && <tr><td colSpan={4} className="text-center text-slate-400 py-12 text-xs">No activity.</td></tr>}
            {filtered.map((e) => (
              <tr key={e.id} className="border-t border-slate-100">
                <td className="whitespace-nowrap text-slate-500 text-xs">{formatDate(e.created_at)}</td>
                <td><span className="text-slate-800">{e.actor_name}</span> <span className="text-[10px] uppercase tracking-wide text-slate-400">{e.actor_role}</span></td>
                <td className="text-slate-700">{humanize(e.action)}</td>
                <td className="text-slate-500 truncate max-w-[320px]">{detailOf(e)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
